import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../../App/Hooks/reduxHooks'
import { setOpenEventDetails } from '../../../../store/calendarSlice'
import { IAppointment } from '../../../../types'

import {
  AbsoluteIcon,
  BtnText,
  ButtonIcon,
  ButtonWrapper,
  CheckoutButton,
  CopyButton,
  CutButton,
  NoShowButton,
  PasteWrapper,
} from './style'

interface IProps {
  appointmentDetails: IAppointment
}

export const ActionButtons: FunctionComponent<IProps> = ({
  appointmentDetails,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const customerUuid: string = appointmentDetails.customer.uuid
  const navigateToCheckout = (): void => {
    window.open(`https://client.optios.wip/register/receipt/${customerUuid}`)
  }
  const copyOrCutAction = (actionType: 'copy' | 'cut') => {
    dispatch(
      setOpenEventDetails({
        openFormDetails: {
          type: actionType,
          event: appointmentDetails,
        },
      }),
    )
  }
  return (
    <ButtonWrapper>
      <PasteWrapper>
        <CopyButton onClick={() => copyOrCutAction('copy')}>
          <ButtonIcon icon="clone" />
        </CopyButton>
        <CutButton onClick={() => copyOrCutAction('cut')}>
          <ButtonIcon icon="hand-scissors" />
        </CutButton>
        <PasteWrapper />
      </PasteWrapper>
      <CheckoutButton onClick={navigateToCheckout}>
        <AbsoluteIcon icon="euro-sign" />
        <BtnText>{t('Checkout')}</BtnText>
      </CheckoutButton>
      <NoShowButton>
        <AbsoluteIcon icon="ban" />
        <BtnText>{t('No Show')}</BtnText>
      </NoShowButton>
    </ButtonWrapper>
  )
}
